import { PERMISSIONS } from '../../constants';
import list from './DevRequestList';
import create from './DevRequestCreate';
import edit from './DevRequestEdit';
import show from './DevRequestShow';

// Interno PontuaX. O nome é o path da API (GET /dev-requests). O gate de verdade (isAdmin E dev-request)
// é o InternalGate das telas; `permissions` aqui só decide se o resource é registrado.
export default {
  list,
  create,
  edit,
  show,
  name: 'dev-requests',
  permissions: [PERMISSIONS.DEV_REQUEST],
};
